export enum UpdatePasswordFieldName {
  OldPassword = 'Old Password',
  NewPassword = 'New Password',
  ConfirmNewPassword = 'Confirm New Password',
}
